import { Clock, LogOut, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PendingApprovalPage() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4 py-12 bg-slate-50" data-testid="pending-page">
            <div className="w-full max-w-xl bg-white border border-slate-300 shadow-[6px_6px_0_0_rgba(15,23,42,0.9)]">
                <div className="p-8">
                    <div className="w-16 h-16 bg-amber-100 border border-amber-300 flex items-center justify-center mb-4">
                        <Clock className="w-8 h-8 text-amber-700" />
                    </div>
                    <div className="label-kicker mb-2 text-amber-700">Access status</div>
                    <h1 className="font-display font-black text-3xl uppercase leading-tight">
                        Awaiting admin<br />approval.
                    </h1>
                    <p className="mt-4 text-slate-600 leading-relaxed">
                        Hi <span className="font-semibold text-slate-900">{user?.name}</span>, thanks for registering.
                        Your account is now <span className="font-mono font-semibold text-amber-700">PENDING</span>.
                        The administrator must approve your access before you can browse the catalog or see prices.
                    </p>

                    <div className="mt-6 border border-slate-200 p-4 font-mono text-xs bg-slate-50 space-y-1.5" data-testid="pending-info">
                        <div className="flex justify-between">
                            <span className="text-slate-500">EMAIL</span>
                            <span className="text-slate-900">{user?.email}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-slate-500">STATUS</span>
                            <span className="text-amber-700 font-semibold">● PENDING</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-slate-500">NEXT STEP</span>
                            <span className="text-slate-900">Wait for admin approval</span>
                        </div>
                    </div>

                    <div className="mt-6 flex items-center gap-3 text-sm text-slate-600">
                        <Mail className="w-4 h-4" />
                        <span>You will be notified when your account is activated. Check back later.</span>
                    </div>

                    <button onClick={logout} className="btn-outline mt-6 inline-flex" data-testid="pending-logout">
                        <LogOut className="w-4 h-4" /> Log out
                    </button>
                </div>
                <div className="px-8 py-3 border-t border-slate-200 bg-slate-50 text-xs font-mono text-slate-500">
                    Need urgent access? Contact the administrator directly.
                </div>
            </div>
        </div>
    );
}
